// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".iconStar path[data-v-40408320]{fill:#edeef1;stroke:#edeef1}.iconStar.active path[data-v-40408320]{fill:#ffd140;stroke:#ffd140}.iconStar.active.VTB path[data-v-40408320]{fill:#ee8f40;stroke:#ee8f40}.iconStar.VTB path[data-v-40408320]{fill:#fff;stroke:#ee8f40}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
